<!--
 * @Author: your name
 * @Date: 2021-04-09 15:43:48
 * @LastEditTime: 2021-04-12 13:58:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/blogger/index.vue
-->
<template>
  <div>
    <div class="main-container">
      <div class="tab-wrap">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="list">全部博主</el-menu-item>
          <!-- <el-menu-item index="add">新增博主</el-menu-item> -->
        </el-menu>
      </div>
      <div class="content-wrap">
        <List v-if="activeIndex === 'list'"></List>
        <Add v-else></Add>
      </div>
    </div>
  </div>
</template>

<script>
import List from "./bzList/list"
import Add from "./bzList/add"
export default {
  components: {List,Add},
  data () {
    return {
      activeIndex: 'list',
    }
  },
  methods: {
    handleSelect(key, keyPath) {
        this.activeIndex = key;
    },
  },
  computed: {
  },
  mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.main-container{
    margin: 20px;
}
</style>